import { useGLTF, useTexture } from '@react-three/drei';
import gsap from 'gsap';

import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { DarkGreen } from './DarkGreen';
import { DarkTall } from './DarkTall';
import { GreenPink } from './GreenPink';
import { Pink } from './Pink';
import { Roses } from './Roses';

useGLTF.preload('/Outside.glb');
useTexture.preload('/env/Arcs.jpg');
useTexture.preload('/env/Base.webp');
useTexture.preload('/env/Floor.jpg');
useTexture.preload('/env/pillers.jpg');
useTexture.preload('/env/Wood.jpg');
useTexture.preload('/env/rocks.jpg');
useTexture.preload('/env/sides.jpg');
useTexture.preload('/env/dresses.jpg');
useTexture.preload('/env/Avatars.jpg');
useTexture.preload('/env/pngTree.webp');



export default function Outside() {

  const group = useRef();
  const { scene } = useGLTF('/Outside.glb');
  const Arc = useTexture('/env/Arcs.jpg');
  Arc.colorSpace = THREE.SRGBColorSpace;
  Arc.flipY = false;
  Arc.generateMipmaps = false;
  Arc.channel = 1;

  const Floor = useTexture('/env/Floor.jpg');
  Floor.colorSpace = THREE.SRGBColorSpace;
  Floor.flipY = false;
  Floor.generateMipmaps = false;
  Floor.channel = 1;

  const Hero = useTexture('/env/pngTree.webp');
  Hero.colorSpace = THREE.SRGBColorSpace;
  Hero.flipY = false;
  Hero.generateMipmaps = false;
  Hero.channel = 1;

  const Base = useTexture('/env/Base.webp');
  Base.colorSpace = THREE.SRGBColorSpace;
  Base.flipY = false;
  Base.generateMipmaps = false;
  Base.channel = 1;


  const Pillers = useTexture('/env/pillers.jpg');
  Pillers.colorSpace = THREE.SRGBColorSpace;
  Pillers.flipY = false;
  Pillers.generateMipmaps = false;
  Pillers.channel = 1;


  const Dresses = useTexture('/env/dresses.jpg');
  Dresses.colorSpace = THREE.SRGBColorSpace;
  Dresses.flipY = false;
  Dresses.generateMipmaps = false;
  Dresses.channel = 1;


  const Avatars = useTexture('/env/Avatars.jpg');
  Avatars.colorSpace = THREE.SRGBColorSpace;
  Avatars.flipY = false;
  Avatars.generateMipmaps = false;
  Avatars.channel = 1;

  const Wood = useTexture('/env/Wood.jpg');
  Wood.colorSpace = THREE.SRGBColorSpace;
  Wood.flipY = false;
  Wood.generateMipmaps = false;
  Wood.channel = 1;

  const Rocks = useTexture('/env/rocks.jpg');
  Rocks.colorSpace = THREE.SRGBColorSpace;
  Rocks.flipY = false;
  Rocks.generateMipmaps = false;
  Rocks.channel = 1;

  const Sides = useTexture('/env/sides.jpg');
  Sides.colorSpace = THREE.SRGBColorSpace;
  Sides.flipY = false;
  Sides.generateMipmaps = false;
  Sides.channel = 1;

  useEffect(() => {
    scene.traverse((node) => {
      if (node.isMesh) {
        if (node.name === 'Frame001') {
          gsap.to(node.rotation, {
            y: -Math.PI / 2,
            duration: 2.5, // Animation duration in seconds
          });
        }

        if (node.name === 'arcs') {
          node.material = new THREE.MeshBasicMaterial({
            map: Arc,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }
        if (node.name === 'sides') {
          node.material = new THREE.MeshBasicMaterial({
            map: Sides,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }
        if (node.name === 'rocks') {
          node.material = new THREE.MeshBasicMaterial({
            map: Rocks,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }

        if (node.name.includes('Avatar')) {
          node.material = new THREE.MeshBasicMaterial({
            map: Avatars,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }

        if (node.name.includes('dress')||node.name.includes('shoe')) {
          node.material = new THREE.MeshBasicMaterial({
            map: Dresses,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }
        if (node.name === 'hero') {
          node.material = new THREE.MeshBasicMaterial({
            map: Hero,
            toneMapped: false,
            side: THREE.DoubleSide,
            // alphaTest:.5,
          });
        }
        if (node.name === 'pillers') {
          node.material = new THREE.MeshBasicMaterial({
            map: Pillers,
            toneMapped: false,
            side: THREE.DoubleSide,
          });
        }
        if (node.name === 'floor001') {
          node.material = new THREE.MeshBasicMaterial({
            map: Floor,
            toneMapped: false,
          });
        }
        if (node.name === 'base') {
          node.material = new THREE.MeshBasicMaterial({
            map: Base,
            toneMapped: false,
          });
        }
        if (node.name === 'wood') {
          node.material = new THREE.MeshBasicMaterial({
            map: Wood,
            toneMapped: false,
          });
        }
        if (node.name === 'Sphere') {
          node.material = new THREE.MeshBasicMaterial({
            map: Sky,
            toneMapped: false,
            side:THREE.DoubleSide
          });
        }

      }
    });
  }, [scene]);

  return (
    <>
        {/* <Perf></Perf> */}
      <Pink jsonFile={'/jsons/pink.json'} ></Pink>
      <Roses jsonFile={'/jsons/roses.json'} ></Roses>
      <GreenPink jsonFile={'/jsons/greenPink.json'}></GreenPink> 
      <DarkGreen jsonFile={'/jsons/darkGreen.json'} ></DarkGreen>
      <DarkTall jsonFile={'/jsons/darkTall.json'}></DarkTall>
      <primitive ref={group} object={scene} />

    </>
  );
}
